import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M0 8a8.01 8.01 0 0 1 8-8 8.01 8.01 0 0 1 8 8 8.01 8.01 0 0 1-8 8 8.01 8.01 0 0 1-8-8zm1.285 0c0 3.703 3.013 6.716 6.716 6.716S14.716 11.703 14.716 8 11.703 1.284 8 1.284 1.285 4.297 1.285 8zM8 5.333a1 1 0 1 0 0-2 1 1 0 1 0 0 2zm0 1.333h-.667c-.177 0-.346.07-.471.195s-.195.295-.195.471.07.346.195.471.295.195.471.195H8v4c0 .177.07.346.195.471s.295.195.471.195.346-.07.471-.195.195-.295.195-.471V8c0-.354-.14-.693-.391-.943S8.354 6.667 8 6.667z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgInfo;
